import { render, staticRenderFns } from "./DiaryShow.vue?vue&type=template&id=08e816d6"
import script from "./DiaryShow.vue?vue&type=script&lang=ts"
export * from "./DiaryShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports